var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 3.1,
    width: 4.3,
    height: 12.2,
    rx: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 7.4,
    width: 4.3,
    height: 7.9,
    rx: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 9.6,
    width: 4.3,
    height: 5.7,
    rx: 1.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.56585d6d6c6f616d87646b1e67bf3f94.svg";
export { ForwardRef as ReactComponent };